import {initContract} from '@ts-rest/core';
import {z} from 'zod';

const c = initContract();

// Presigned-PUT upload flow. The browser cannot POST multipart bodies larger
// than ~6 MB through CloudFront → Lambda Function URL (BUFFERED FURLs hard-cap
// request payload at 6 MB), so uploads instead go:
//
//   1. POST /upload/presign — server validates auth + KB perms, creates a
//      `sources` row in `pending`, and returns a short-lived S3 PUT URL.
//   2. PUT <putUrl> — browser uploads bytes directly to S3 (bypasses
//      CloudFront entirely; the source bucket has CORS for this).
//   3. POST /upload/complete — server emits the FILE_INGESTION EventBridge
//      event so the async `file-ingestion` Lambda picks the file up from S3
//      and runs the parsing / chunking / vectorization pipeline.
//
// A source row that gets stuck in `pending` (PUT or /complete never landed)
// can currently only be cleared via the sources UI — there is no periodic
// sweeper yet.
export const uploadContract = c.router(
  {
    presign: {
      method: 'POST',
      path: '/presign',
      body: z.object({
        kbId: z.string().uuid(),
        filename: z.string().min(1),
        contentType: z.string().min(1)
      }),
      responses: {
        201: z.object({
          sourceId: z.string().uuid(),
          putUrl: z.string().url()
        }),
        403: z.object({error: z.string()}),
        404: z.object({error: z.string()})
      },
      summary: 'Get a presigned S3 PUT URL for a new source upload'
    },
    complete: {
      method: 'POST',
      path: '/complete',
      body: z.object({
        sourceId: z.string().uuid()
      }),
      responses: {
        202: z.object({message: z.string()}),
        403: z.object({error: z.string()}),
        404: z.object({error: z.string()})
      },
      summary: 'Mark a presigned upload as complete and enqueue ingestion'
    }
  },
  {
    pathPrefix: '/upload'
  }
);
